import { render, staticRenderFns } from "./RoutesBox.vue?vue&type=template&id=4b3c9b6c&scoped=true"
import script from "./RoutesBox.vue?vue&type=script&lang=js"
export * from "./RoutesBox.vue?vue&type=script&lang=js"
import style0 from "./RoutesBox.vue?vue&type=style&index=0&id=4b3c9b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c9b6c",
  null
  
)

export default component.exports